import { createFileRoute } from "@tanstack/react-router";

import { AccountProfilePage } from "../iam/account/components/AccountProfilePage";

/**
 * Route is /account/profile: how the user's name appears across Mountaya. This is
 * also where Ory's settings browser-init 303s back to with ?flow=, but the account
 * layout (/_app/account) validates and owns that flow search param — the page reads
 * the loaded flow from context, so the route itself needs no search schema.
 */
export const Route = createFileRoute("/_app/account/profile")({
  component: AccountProfilePage,
});
